async function getUserLocation() {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });
                },
                error => {
                    reject(error);
                }
            );
        } else {
            reject(new Error("Geolocation is not supported by this browser."));
        }
    });
}

async function getUserIpAddress() {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('Error fetching IP address:', error);
        return null;
    }
}

//Ip API permite 1000 requisições por dia e 30000 por mês gratuitas
// async function getUserCityAndState(ip) {
//     try {
//         if (ip) {
//             const response = await fetch(`https://ipapi.co/${ip}/json/`);
//             const data = await response.json();
//             return {
//                 city: data.city,
//                 stateCode: data.region_code,
//             };
//         }
//         return { city: null, stateCode: null };
//     } catch (error) {
//         console.error('Error fetching city and state:', error);
//         return { city: null, stateCode: null };
//     }
// }

async function getUserAllFromIp(ip) {
    try {
        if (ip) {
            const response = await fetch(`https://ipapi.co/${ip}/json/`);
            const data = await response.json();
            return data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching all data from IP:', error);
        return null;
    }
}

async function getCityByLatitudeAndLongitude(latitude, longitude) {
    try {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
        const data = await response.json();
        return {
            all: data
        };
    } catch (error) {
        console.error('Error fetching city by latitude and longitude:', error);
        return null;
    }
}

/**
 * Retorna um objeto ChapterAccess preenchido com dados de localização e IP.
 * chapterId e userName (visitorId) são deixados como null para serem setados posteriormente.
 */
async function getChapterAccessFromLocationData() {
    const chapterAccess = {
        locationLongitude: null,
        locationLatitude: null,
        stateCode: null,
        city: null,
        ip: null,
        createdAt: new Date().toISOString(),
        chapterId: null,
        visitorName: null
    };

    try {
        const ip = await getUserIpAddress();
        if (ip) {
            chapterAccess.ip = ip;
        }
    } catch (error) {
        console.warn("Não foi possível obter o endereço IP do usuário:", error.message);
    }

    try {
        const location = await getUserLocation();
        if (location) {
            chapterAccess.locationLongitude = location.longitude.toString();
            chapterAccess.locationLatitude = location.latitude.toString();
            const cityData = await getCityByLatitudeAndLongitude(location.latitude, location.longitude);
            if (cityData && cityData.all && cityData.all.address) {
                chapterAccess.city = cityData.all.address.city || cityData.all.address.town || cityData.all.address.village || null;
                chapterAccess.stateCode = cityData.all.address["ISO3166-2-lvl4"]?.replace("BR-", "") || null;
            }
            return chapterAccess;
        }
    } catch (error) {
        console.warn("Não foi possível obter a localização do usuário via Geolocation API:", error.message);
    }

    try {
        const ip = chapterAccess.ip;
        const ipData = await getUserAllFromIp(ip);
        if (ipData) {
            chapterAccess.city = ipData.city;
            chapterAccess.stateCode = ipData.region_code;
            // Se a localização via IP for mais precisa ou fallback
            if (!chapterAccess.locationLongitude && ipData.longitude) {
                chapterAccess.locationLongitude = ipData.longitude.toString();
            }
            if (!chapterAccess.locationLatitude && ipData.latitude) {
                chapterAccess.locationLatitude = ipData.latitude.toString();
            }
        }
    } catch (error) {
        console.warn("Não foi possível obter dados de IP e localização via ipapi.co:", error.message);
    } finally {
        return chapterAccess;
    }
}

export { getChapterAccessFromLocationData };


